module.exports = __webpack_public_path__ + "img/result.535195a5.png";